(function () {
  'use strict';

  var CATEGORY_LABELS = {
    all: 'All stories',
    first_setup: 'First setup',
    mapping_control: 'Mapping and control',
    everyday_mowing: 'Everyday mowing',
    finished_lawns: 'Finished lawns',
    life_with_lopkin: 'Life with LOPKIN'
  };

  function pushEvent(eventName, detail) {
    if (!window.dataLayer) return;
    try {
      window.dataLayer.push(Object.assign({ event: eventName }, detail || {}));
    } catch (e) {}
  }

  function boot(root) {
    if (!root || root.dataset.lpStoriesReady === 'true') return;
    root.dataset.lpStoriesReady = 'true';

    var sectionId = root.getAttribute('data-section-id') || '';
    var perPage = parseInt(root.getAttribute('data-per-page') || '6', 10);
    if (!perPage || perPage < 1) perPage = 6;

    var gridWrap = root.querySelector('[data-lp-stories-grid-wrap]');
    var grid = root.querySelector('[data-lp-stories-grid]');
    var emptyEl = root.querySelector('[data-lp-stories-empty]');
    var pagination = root.querySelector('[data-lp-stories-pagination]');
    var pagePrev = root.querySelector('[data-lp-stories-page-prev]');
    var pageNext = root.querySelector('[data-lp-stories-page-next]');
    var pageInfo = root.querySelector('[data-lp-stories-page-info]');
    var filterTabs = root.querySelectorAll('[data-lp-stories-filter-tab]');
    var filterSelect = root.querySelector('[data-lp-stories-filter-select]');
    var filterDropdown = root.querySelector('[data-lp-stories-filter-dropdown]');

    var modal = root.querySelector('[data-lp-stories-modal]');
    var modalPanel = root.querySelector('[data-lp-stories-modal-panel]');
    var modalClose = root.querySelector('[data-lp-stories-modal-close]');
    var modalMedia = root.querySelector('[data-lp-stories-modal-media]');
    var modalCategory = root.querySelector('[data-lp-stories-modal-category]');
    var modalTitle = root.querySelector('[data-lp-stories-modal-title]');
    var modalBody = root.querySelector('[data-lp-stories-modal-body]');
    var modalOwner = root.querySelector('[data-lp-stories-modal-owner]');
    var modalPrev = root.querySelector('[data-lp-stories-modal-prev]');
    var modalNext = root.querySelector('[data-lp-stories-modal-next]');

    var allCards = Array.prototype.slice.call(root.querySelectorAll('[data-lp-stories-card]'));
    var currentCategory = 'all';
    var currentPage = 1;
    var visibleCards = [];
    var activeModalIndex = -1;
    var lastFocus = null;
    var fadeMs = 210;

    function getFilteredCards() {
      return allCards.filter(function (card) {
        var cat = card.getAttribute('data-category') || '';
        return currentCategory === 'all' || cat === currentCategory;
      });
    }

    function updateFilterUi() {
      filterTabs.forEach(function (tab) {
        var val = tab.getAttribute('data-lp-stories-filter-tab') || 'all';
        tab.classList.toggle('is-active', val === currentCategory);
        tab.setAttribute('aria-pressed', val === currentCategory ? 'true' : 'false');
      });
      if (filterSelect) filterSelect.value = currentCategory;
      if (filterDropdown) filterDropdown.value = currentCategory;
    }

    function renderPage() {
      visibleCards = getFilteredCards();
      var totalPages = Math.max(1, Math.ceil(visibleCards.length / perPage));
      if (currentPage > totalPages) currentPage = 1;

      if (gridWrap) {
        gridWrap.classList.remove('is-visible');
        gridWrap.classList.add('is-fading');
      }

      window.setTimeout(function () {
        allCards.forEach(function (card) {
          card.hidden = true;
        });

        if (visibleCards.length === 0) {
          if (emptyEl) emptyEl.hidden = false;
          if (pagination) pagination.hidden = true;
          if (grid) grid.hidden = true;
        } else {
          if (emptyEl) emptyEl.hidden = true;
          if (grid) grid.hidden = false;
          if (pagination) pagination.hidden = totalPages <= 1;

          var start = (currentPage - 1) * perPage;
          var pageCards = visibleCards.slice(start, start + perPage);
          pageCards.forEach(function (card) {
            card.hidden = false;
          });

          if (pageInfo) pageInfo.textContent = currentPage + ' / ' + totalPages;
          if (pagePrev) pagePrev.disabled = currentPage <= 1;
          if (pageNext) pageNext.disabled = currentPage >= totalPages;
        }

        if (gridWrap) {
          gridWrap.classList.remove('is-fading');
          gridWrap.classList.add('is-visible');
        }
      }, fadeMs);
    }

    function setCategory(cat) {
      if (cat === currentCategory) return;
      currentCategory = cat;
      currentPage = 1;
      updateFilterUi();
      renderPage();
      pushEvent('owner_story_filter', {
        section_id: sectionId,
        category_key: currentCategory
      });
    }

    filterTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setCategory(tab.getAttribute('data-lp-stories-filter-tab') || 'all');
      });
    });

    if (filterSelect) {
      filterSelect.addEventListener('change', function () {
        setCategory(filterSelect.value || 'all');
      });
    }

    if (filterDropdown) {
      filterDropdown.addEventListener('change', function () {
        setCategory(filterDropdown.value || 'all');
      });
    }

    if (pagePrev) {
      pagePrev.addEventListener('click', function () {
        if (currentPage > 1) {
          currentPage -= 1;
          renderPage();
        }
      });
    }

    if (pageNext) {
      pageNext.addEventListener('click', function () {
        var totalPages = Math.max(1, Math.ceil(getFilteredCards().length / perPage));
        if (currentPage < totalPages) {
          currentPage += 1;
          renderPage();
        }
      });
    }

    function pauseModalVideo() {
      if (!modalMedia) return;
      var video = modalMedia.querySelector('video');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    }

    function resolveOrientation(card) {
      var orientation = card.getAttribute('data-media-orientation') || 'landscape';
      if (orientation === 'auto') {
        return card.getAttribute('data-modal-orientation') || 'landscape';
      }
      return orientation;
    }

    function buildModalMedia(card) {
      if (!modalMedia) return;
      modalMedia.innerHTML = '';
      var type = card.getAttribute('data-media-type') || 'image';
      var modalSrc = card.getAttribute('data-modal-src') || '';
      var poster = card.getAttribute('data-modal-poster') || '';
      var alt = card.getAttribute('data-alt') || '';

      if (!modalSrc) return;

      if (type === 'video') {
        var video = document.createElement('video');
        video.src = modalSrc;
        video.controls = true;
        video.preload = 'none';
        video.playsInline = true;
        if (poster) video.poster = poster;
        video.addEventListener('play', function () {
          pushEvent('owner_story_media_play', {
            section_id: sectionId,
            media_type: 'video'
          });
        });
        modalMedia.appendChild(video);
      } else {
        var img = document.createElement('img');
        img.src = modalSrc;
        img.alt = alt;
        img.loading = 'lazy';
        modalMedia.appendChild(img);
      }
    }

    function openModal(index) {
      visibleCards = getFilteredCards();
      if (!modal || index < 0 || index >= visibleCards.length) return;
      activeModalIndex = index;
      var card = visibleCards[index];
      lastFocus = document.activeElement;

      var orientation = resolveOrientation(card);
      var layout = modalPanel ? modalPanel.querySelector('[data-lp-stories-modal-layout]') : null;
      if (layout) {
        layout.classList.toggle('lp-stories__modal-layout--portrait', orientation === 'portrait');
      }

      buildModalMedia(card);

      var catKey = card.getAttribute('data-category') || '';
      if (modalCategory) modalCategory.textContent = CATEGORY_LABELS[catKey] || catKey;
      if (modalTitle) modalTitle.textContent = card.getAttribute('data-story-title') || '';
      var contentEl = card.querySelector('[data-lp-stories-content]');
      if (modalBody) modalBody.innerHTML = contentEl ? contentEl.innerHTML : '';
      if (modalOwner) modalOwner.textContent = card.getAttribute('data-owner-name') || '';

      if (modalPrev) modalPrev.disabled = index <= 0;
      if (modalNext) modalNext.disabled = index >= visibleCards.length - 1;

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (modalClose) modalClose.focus();

      pushEvent('owner_story_open', {
        section_id: sectionId,
        category_key: catKey,
        media_type: card.getAttribute('data-media-type') || 'image'
      });
    }

    function closeModal() {
      if (!modal) return;
      pauseModalVideo();
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      activeModalIndex = -1;
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    allCards.forEach(function (card, idx) {
      card.addEventListener('click', function () {
        visibleCards = getFilteredCards();
        var start = (currentPage - 1) * perPage;
        var pageCards = visibleCards.slice(start, start + perPage);
        var pageIndex = pageCards.indexOf(card);
        if (pageIndex >= 0) openModal((currentPage - 1) * perPage + pageIndex);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          card.click();
        }
      });
    });

    if (modalClose) modalClose.addEventListener('click', closeModal);
    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal();
      });
    }

    if (modalPrev) {
      modalPrev.addEventListener('click', function () {
        if (activeModalIndex > 0) openModal(activeModalIndex - 1);
      });
    }

    if (modalNext) {
      modalNext.addEventListener('click', function () {
        if (activeModalIndex < visibleCards.length - 1) openModal(activeModalIndex + 1);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (!modal || !modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        closeModal();
      }
    });

    updateFilterUi();
    if (gridWrap) gridWrap.classList.add('is-visible');
    renderPage();
  }

  function initAll() {
    document.querySelectorAll('[data-lp-stories]').forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var targets = e.target ? e.target.querySelectorAll('[data-lp-stories]') : [];
    if (!targets.length && e.target && e.target.matches && e.target.matches('[data-lp-stories]')) {
      targets = [e.target];
    }
    targets.forEach(function (el) {
      el.dataset.lpStoriesReady = 'false';
      boot(el);
    });
  });
})();
